import React, { useState, useRef, useEffect } from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Hero from "../components/Hero";
import WavesTop from "../components/WavesTop";
import GuestFeatures from "../components/GuestFeatures";
import WavesBottom from "../components/WavesBottom";
import PressCards from "../components/PressCards";
import CallToAction from "../components/CallToAction";
import { PageRendererProps, graphql, StaticQuery } from "gatsby";
import StoreBadges from "../components/StoreBadges";
import YouTube from "react-youtube-embed";
import OrderTypeDescription from "../components/OrderTypeDescription";
import Gastronomies from "../components/Gastronomies";

// import Config from "./../config";
// import MessengerCustomerChat from "react-messenger-customer-chat";

const query = graphql`
  query AppQuery {
    site {
      siteMetadata {
        iosClient
        androidClient
      }
    }
  }
`;

const IndexPage = ({ location }: PageRendererProps) => {
  const [showVideo, setShowVideo] = useState(false);

  const container = useRef<any>(null);

  useEffect(() => {
    const onVideoIntersection = (entries) => {
      if (!entries || entries.length <= 0) {
        return;
      }

      if (entries[0].isIntersecting) {
        setShowVideo(true);
        videoObserver.disconnect();
      }
    };

    const videoObserver = new IntersectionObserver(onVideoIntersection);

    if (window && "IntersectionObserver" in window) {
      if (container && container.current) {
        videoObserver.observe(container.current);
      }
    } else {
      setShowVideo(true);
    }
  }, [container]);

  return (
    <StaticQuery
      query={query}
      render={(data) => (
        <Layout location={location}>
          <Seo
            title="Deine digitale Speisekarte"
            description="Inspirieren - Stöbern - Genießen. Mit getsby, deiner digitale Speisekarte!"
            keywords={[
              `getsby`,
              `Bestellen`,
              `Bezahlen`,
              `Take-Away`,
              `Lieferung`,
              `Kontaktlos`,
            ]}
          />

          <Hero
            keywords="Inspirieren - Stöbern - Genießen"
            title="Deine digitale Speisekarte!"
            subTitle="Bestelle & Bezahle mit getsby auf deinem Smartphone!"
            imgSrc={require("../images/phone-index.png")}
            deviceType="ios"
            callToAction={
              <StoreBadges
                ios={{ link: data.site.siteMetadata.iosClient }}
                android={{ link: data.site.siteMetadata.androidClient }}
              />
            }
          />

          <WavesTop />

          <Gastronomies
            description={
              <h3 className="mx-6 mt-16 text-3xl font-bold leading-none text-center text-gray-800">
                ... hier findest du uns!
              </h3>
            }
            footer={
              <p className="mx-6 text-center text-gray-600">
                Dein Lieblingsrestaurant ist noch nicht dabei? Dann sende uns
                einfach eine{" "}
                <a
                  href="mailto:office@gets.by?subject=Mein Lieblingsrestaurant"
                  className="text-yellow-500"
                >
                  Nachricht
                </a>
                !
              </p>
            }
          />

          <GuestFeatures />

          <OrderTypeDescription />

          <WavesBottom fillColor="#ffffff" />

          <section className="py-8">
            <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-white">
              Und so einfach funktioniert's
            </h1>
            <div className="w-full mb-4">
              <div className="w-1/6 h-1 py-0 mx-auto my-0 bg-white rounded-t opacity-25" />
            </div>
            <div
              className="container flex flex-wrap pt-4 pb-12 mx-auto"
              ref={container}
            >
              {showVideo && <YouTube id="xtXN7K3mEgw" />}
            </div>
          </section>

          <WavesTop fillColor="#f8fafc" />

          <PressCards />

          <WavesBottom fillColor="#f8fafc" />

          <CallToAction
            title="Weniger warten - mehr Zeit zum Genießen!"
            subTitle="Jetzt ausprobieren & kostenlose App herunterladen!"
            callToAction={
              <StoreBadges
                ios={{ link: data.site.siteMetadata.iosClient }}
                android={{ link: data.site.siteMetadata.androidClient }}
              />
            }
          />

          {/* 
          <MessengerCustomerChat
            pageId={Config.facebookPageId}
            appId={Config.facebookAppId}
            themeColor={"#f0c314"}
            language="de_DE"
            loggedInGreeting="Hi! Wie können wir dir helfen?"
            loggedOutGreeting="Hi! Wie können wir dir helfen?"
          />
          */}
        </Layout>
      )}
    />
  );
};

export default IndexPage;
